import { getPurchaseToken } from 'actions/memberships';
import { Button } from 'components/atoms/Button/Button';
import { PurchaseForm } from 'components/User/Card/PurchaseForm';
import PropTypes from 'prop-types';
import { formatCurrency, goToCustomUrl } from 'controls/utils';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './_MemberShipItem.scss';
import { MEMBERSHIPS_ACTIONS } from './MembershipActions';

export const MembershipItem = ({
  item, updateParent,
}) => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [purchaseToken, setPurchaseToken] = useState(false);
  const [CTAlabel, setCTAlabel] = useState('');

  /* use relative path or might be problems redirecting
  https://rolandvs.atlassian.net/browse/RCP-5056
  */
  const loginAndRedirectUrl = `${window.location.origin}/roland-account/login?redirect=${window.location.origin}${process.env.REACT_APP_BASE_PATH}`;
  const accountDetailsUrl = `${window.location.origin}/roland-account`;

  const {
    image, price, description, offerId, productIds, customerEligible, isActive, isFreeTrial, isUpgrade, isPurchasable,
  } = item;

  const goToLogin = () => {
    window.location.href = loginAndRedirectUrl;
  };

  const getCTALabel = useCallback(
    () => {

      if (isFreeTrial) {
        return MEMBERSHIPS_ACTIONS.freeTrial;
      }

      if (isActive) {
        return MEMBERSHIPS_ACTIONS.active;
      }

      if (isUpgrade) {
        return MEMBERSHIPS_ACTIONS.upgrade;
      }

      if (isPurchasable) {
        return MEMBERSHIPS_ACTIONS.purchasable;
      }

      return MEMBERSHIPS_ACTIONS.unavailable;

    },
    [isFreeTrial, isActive, isUpgrade, isPurchasable],
  );

  useEffect(() => {

    setCTAlabel(getCTALabel());
  }, [getCTALabel]);

  const getTokenAndPay = useCallback(async () => {
    setLoading(true);
    const token = await dispatch(getPurchaseToken(offerId, productIds));

    if (token !== false) {
      setPurchaseToken(token);
      setShowModal(true);
    }

    setLoading(false);
  }, [dispatch, offerId, productIds]);

  const onItemCancel = () => {
    setShowModal(!showModal);
    updateParent();
  };

  const getCTAAction = () => {
    if (customerEligible) {
      if (!userInfo.guest) {
        getTokenAndPay();
      } else {
        goToLogin();
      }

    } else if (CTAlabel === MEMBERSHIPS_ACTIONS.active) {
      goToCustomUrl(accountDetailsUrl);
    }
  };

  return (
    <div className='membership-item'>
      { showModal && <PurchaseForm url={`${process.env.REACT_APP_BUY_SCRIPT}?data=${purchaseToken}&session=${userInfo?.idToken}`} onCancel={onItemCancel} /> }
      <img src={image.url} alt='asd' loading='lazy' />
      <div className='membership-item__info'>
        <span className='membership-item__title'>{description.us}</span>
        <span className='membership-item__price'>
          {formatCurrency(price)}
        </span>
        <Button text={CTAlabel} extraStyle='self-center' loading={loading || showModal} disabled={CTAlabel === MEMBERSHIPS_ACTIONS.unavailable} onClick={getCTAAction} />
      </div>
    </div>
  );
};

MembershipItem.propTypes = {
  item: PropTypes.object.isRequired,
  updateParent: PropTypes.func.isRequired,
};
